<template>
  <b-carousel
    v-if="data.length > 0"
    :arrow="true"
    :items-to-show="slidesPerView"
    :icon-size="iconSize"
    :has-drag="true"
    :autoplay="autoPlay"
    @change="onSlideChange"
  >
    <b-carousel-item
      v-for="(image, index) in data"
      :key="index"
    >
      <!-- Only load the visible slide (and its neighbours); the rest load
           on demand when the user navigates, so a card with 30+ photos
           doesn't download them all upfront. -->
      <img
        v-if="loaded.includes(index)"
        style="pointer-events:none;"
        :src="image.thumb_url || image.url"
        loading="lazy"
        class="image_center"
        :alt="image.file_name"
      >
      <span
        v-else
        class="image_center image_placeholder"
      />
    </b-carousel-item>
  </b-carousel>
  <section
    v-else
    class="hero is-medium is-gray"
  >
    <div
      class="is325 has-text-centered is-flex border-b border-gary is-align-items-center"
    >
      <p class="title is-6">
        {{ $t("not_found_image").capitalize() }}
      </p>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    slidesPerView: {
      default: 1,
      type: Number
    },
    gap: {
      default: 50,
      type: Number
    },
    arrowBoth: {
      default: true,
      type: Boolean
    },
    arrowHover: {
      default: true,
      type: Boolean
    },
    autoPlay: {
      default: false,
      type: Boolean
    },
    iconSize: {
      default: "",
      type: String
    },
    data: {
      default() {
        return [];
      },
      type: Array
    }
  },
  data() {
    return {
      // Slide indexes whose image has been loaded (first one eagerly).
      loaded: [0]
    };
  },
  methods: {
    onSlideChange(index) {
      // Load the current slide plus its immediate neighbours for smooth nav.
      [index - 1, index, index + 1].forEach((i) => {
        if (i >= 0 && i < this.data.length && !this.loaded.includes(i)) {
          this.loaded.push(i);
        }
      });
    }
  }
};
</script>

<style>
.is325 {
  width: 325px;
  height: 325px;
}
.border-b {
  border-bottom: solid 1px;
}
.border-gary {
  border-color: #f4f4f4;
}
.image_center {
  height: 250px !important;
  width: 100%;
  object-fit: cover;
}
.image_placeholder {
  display: block;
  background: #f4f4f4;
}
</style>
